<template>
    <b-navbar toggleable="md">
        <div class="mx-auto d-sm-flex d-block flex-sm-nowrap">
            <b-navbar-toggle target="nav_collapse_guardian"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse_guardian" class="text-center collapse navbar-collapse">
                <b-navbar-nav>

                    <b-nav-item :to="'/guardians/guardians'">
                        {{ $t('menu.items.guardians.guardians') }}
                    </b-nav-item>
                    <b-nav-item :to="'/guardians/proteges'">
                        {{ $t('menu.items.guardians.proteges') }}
                    </b-nav-item>
                    <b-nav-item :to="'/guardians/invitations'">
                        {{ $t('menu.items.guardians.invitations') }}
                    </b-nav-item>

                </b-navbar-nav>
            </b-collapse>
        </div>
    </b-navbar>
</template>

<script>

    export default {
        name: 'MiscMenu'
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/custom/vars';

    #nav_collapse_guardian > ul > li > a {
        color: white;
        &:hover {
            text-decoration: none;
            color: $omyfu-hover;
        }
    }

    #nav_collapse_guardian > ul > li > a.active {
        color: $omyfu-yellow;
    }

    .navbar {
        background-color: $omyfu-red;
        padding: 0px;
    }

</style>



// WEBPACK FOOTER //
// src/components/guardian/GuardiansMenuComponent.vue